import React from "react";
import { t } from "ttag";

import { ConnectWithDealerForm } from "../../CRMForm/ConnectWithDealerForm";
import { SlideoverModal } from "../../SlideoverModal/SlideoverModal";

import slideoverStyles from "../../SlideoverModal/SlideoverModal.module.scss";
import styles from "./ConnectDealerModal.module.scss";

export type ConnectDealerModalProps = {
    isOpen: boolean;
    onClose: () => void;
};

export const ConnectDealerModal = ({
    isOpen,
    onClose,
}: ConnectDealerModalProps) => (
    <SlideoverModal
        isOpen={isOpen}
        onClose={onClose}
        theme="offWhite"
        title={t`Connect with a Dealer`}
        titleClassName={styles.title}
        panelClassName={styles.panel}
    >
        <div className={slideoverStyles.body}>
            <ConnectWithDealerForm custom_submit_url={null} />
        </div>
    </SlideoverModal>
);
